import React, { useState } from 'react';
import useSendEmail from '../hooks/useSendEmail'; // Import the hook

const SendEmail = () => {
    const [messageBody, setMessageBody] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    
    const { sendEmail, response, error } = useSendEmail(); // Call the custom hook

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Call the sendSMS function when form is submitted
        await sendEmail(subject,messageBody, email);   
    };
 

    return (
        <div>
            <h1>Send SMS</h1>
            <form onSubmit={handleSubmit}>
                {/* <div>
                    <label>Transaction ID:</label>
                    <input
                        type="text"
                        value={transactionId}
                        onChange={(e) => setTransactionId(e.target.value)}
                    />
                </div>*/}
                 <div>
                    <label> Subject:</label>
                    <textarea
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                    />
                </div>
                <div>
                    <label>Message Body:</label>
                    <textarea
                        value={messageBody}
                        onChange={(e) => setMessageBody(e.target.value)}
                    />
                </div>
                <div>
                    <label>Email Addresss:</label>
                    <input
                        type="text"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div> 
                <button type="submit">Send Email</button>
            </form>

            {response && (
                <div>
                    <h2>Response:</h2>
                    <pre>{JSON.stringify(response, null, 2)}</pre>
                </div>
            )}

            {error && (
                <div style={{ color: 'red' }}>
                    <h2>Error:</h2>
                    <pre>{JSON.stringify(error, null, 2)}</pre>
                </div>
            )}
        </div>
    );
};

export default SendEmail;
